<template>
  <div>
    <el-dialog
      :visible.sync="dialogShow"
      class="large-dialog"
      title="设备类型"
      :close-on-click-modal="false"
      v-dialogDrag
    >
      <div class="mb-20px">
        <el-input
          v-model="searchList.keyWord"
          placeholder="关键字检索"
          clearable
          class="!w-150px mr-10px"
          disabled
        ></el-input>
        <el-select
          v-model="searchList.jizu"
          clearable
          placeholder="所属机组"
          class="!w-150px mr-10px"
          disabled
        >
          <el-option label="全部" :value="null"></el-option>
          <el-option label="在线" :value="1"></el-option>
          <el-option label="离线" :value="2"></el-option>
        </el-select>
        <el-select
          v-model="searchList.systems"
          clearable
          placeholder="所属系统"
          class="!w-150px mr-10px"
          disabled
        >
          <el-option label="全部" :value="null"></el-option>
          <el-option label="在线" :value="1"></el-option>
          <el-option label="离线" :value="2"></el-option>
        </el-select>
        <el-select
          v-model="searchList.major"
          clearable
          placeholder="所属专业"
          class="!w-150px mr-10px"
          disabled
        >
          <el-option label="全部" :value="null"></el-option>
          <el-option label="在线" :value="1"></el-option>
          <el-option label="离线" :value="2"></el-option>
        </el-select>
        <el-button size="small" @click="search" type="primary">{{ $t('搜索') }}</el-button>
        <el-button size="small" @click="reset">{{ $t('重置') }}</el-button>
        <el-button type="primary" @click="setPosition">确认关联</el-button>
      </div>
      <el-table
        ref="tableList"
        border
        highlight-current-row
        @selection-change="selectionChange"
        :data="tableData"
        v-model="testList"
        :row-key="(row) => row.id"
        height="calc(100% - 120px)"
        class="text-center"
        v-loading="loading"
      >
        <el-table-column
          :align="alignType"
          type="selection"
          width="60"
          status="checkout"
        ></el-table-column>
        <el-table-column
          label="机组"
          prop="pr_group_code"
          width="120"
          :show-overflow-tooltip="true"
          :align="alignType"
        ></el-table-column>
        <el-table-column
          label="电厂描述"
          prop="pr_system_status"
          width="120"
          :show-overflow-tooltip="true"
          :align="alignType"
        ></el-table-column>
        <el-table-column
          label="kks描述"
          prop="pr_kks_desc"
          width="120"
          :show-overflow-tooltip="true"
          :align="alignType"
        ></el-table-column>
        <el-table-column
          label="原上级kks"
          prop="pr_y_old_kks"
          width="120"
          :show-overflow-tooltip="true"
          :align="alignType"
        ></el-table-column>
        <el-table-column
          label="所属系统"
          prop="pr_sys_name"
          width="120"
          :show-overflow-tooltip="true"
          :align="alignType"
        ></el-table-column>
        <el-table-column
          label="用户状态描述"
          prop="pr_device_status"
          width="120"
          :show-overflow-tooltip="true"
          :align="alignType"
        ></el-table-column>
        <el-table-column
          label="原kks编码"
          prop="pr_old_device_kks_code"
          width="120"
          :show-overflow-tooltip="true"
          :align="alignType"
        ></el-table-column>
        <el-table-column
          label="创建日期"
          prop="pr_creation_date"
          width="120"
          :show-overflow-tooltip="true"
          :align="alignType"
        ></el-table-column>
        <el-table-column
          label="班组"
          prop="pr_team"
          width="120"
          :show-overflow-tooltip="true"
          :align="alignType"
        ></el-table-column>
        <el-table-column
          label="原kks描述"
          prop="pr_old_kks_desc"
          width="120"
          :show-overflow-tooltip="true"
          :align="alignType"
        ></el-table-column>
        <el-table-column
          label="供应商"
          prop="pr_supplier"
          width="120"
          :show-overflow-tooltip="true"
          :align="alignType"
        ></el-table-column>
        <el-table-column
          label="调试单位"
          prop="pr_debugging_unit"
          width="120"
          :show-overflow-tooltip="true"
          :align="alignType"
        ></el-table-column>
        <el-table-column
          label="kks编码"
          prop="pr_device_kks_code"
          width="120"
          :show-overflow-tooltip="true"
          :align="alignType"
        ></el-table-column>
        <el-table-column
          label="设计单位"
          prop="pr_design_unit"
          width="120"
          :show-overflow-tooltip="true"
          :align="alignType"
        ></el-table-column>
        <el-table-column
          label="制造商联系方式"
          prop="pr_maker_phone"
          width="120"
          :show-overflow-tooltip="true"
          :align="alignType"
        ></el-table-column>
        <el-table-column
          label="kks种类"
          prop="pr_kss_species"
          width="120"
          :show-overflow-tooltip="true"
          :align="alignType"
        ></el-table-column>
        <el-table-column
          label="设备定级"
          prop="pr_equipment_grading"
          width="120"
          :show-overflow-tooltip="true"
          :align="alignType"
        ></el-table-column>
        <el-table-column
          label="上级kks"
          prop="pr_parent_kks"
          width="120"
          :show-overflow-tooltip="true"
          :align="alignType"
        ></el-table-column>
        <el-table-column
          label="系统"
          prop="pr_system"
          width="120"
          :show-overflow-tooltip="true"
          :align="alignType"
        ></el-table-column>
        <el-table-column
          label="专业"
          prop="pr_speciality_code"
          width="120"
          :show-overflow-tooltip="true"
          :align="alignType"
        ></el-table-column>
      </el-table>
      <el-pagination
        class="text-right mt-20px mb-10px p-0"
        small
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="initPagination.total"
        :current-page.sync="initPagination.pageNum"
        :page-size="initPagination.pageSize"
        :pager-count="5"
        :page-sizes="[15, 30, 45, 90, 450]"
        @current-change="search"
        @size-change="search"
      >
      </el-pagination>
    </el-dialog>
    <!-- 上传组件 -->
    <wiz-upload-file
      v-dialogDrag
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
      @exportResults="exportResults"
    ></wiz-upload-file>
  </div>
</template>

<script>
import axios from 'axios'
import { wizUploadFile } from '@wiz-core/compts'
import { watch } from 'fs'
import { token } from './constant'

const baseUrl = Wiz.GetModuleServer()
export default {
  props: {
    show: Boolean,
    relevanceDevices: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  components: {
    wizUploadFile,
  },
  watch: {},
  computed: {
    dialogShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      },
    },
  },
  async created() {
    this.search()
  },
  data() {
    return {
      searchList: {
        keywords: '',
        major: '',
        systems: '',
        jizu: '',
      },
      alignType: 'left',
      selectionList: this.relevanceDevices, // 复选框勾选的数据
      initPagination: {
        pageNum: 1,
        pageSize: 15,
        total: 0,
      },
      loading: false, // 表格加载状态
      tableData: [], // 表格数据
      testList: [], // 表格复选框选中数据test
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 0, // 目前状态页面0为下载模板 1为上传模板 2为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
    }
  },
  methods: {
    reset() {
      this.searchList = this.$options.data().searchList
      this.search()
    },
    async search() {
      this.loading = true
      const { pageNum, pageSize } = this.initPagination
      axios({
        method: 'GET',
        url: `${baseUrl}/openapi/devices-info/V1.0?token=portal_js&pageNo=${pageNum}&pageSize=${pageSize}`,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
      })
        .then((result) => {
          const [err, res] = result
          if (err) return
          this.initPagination.total = res.data.totalCount
          this.tableData = res.data.items
          this.selectionToggle()
        })
        .catch((err) => {
          console.log(err)
        })
      this.loading = false
    },
    selectionChange(val) {
      this.selectionList = val
    },
    // 表单选中数据绑定
    selectionToggle() {
      this.selectionList.forEach((item) => {
        this.$nextTick(() => {
          this.tableData.forEach((i) => {
            if (i.prDeviceKksCode === item) {
              this.$refs.tableList.toggleRowSelection(i, true)
            }
          })
        })
      })
    },
    setPosition() {
      const dataList = []
      _.forEach(this.selectionList, (item) => {
        dataList.push(item.pr_device_kks_code)
      })
      this.$emit('update:relevanceDevices', dataList)
      this.dialogShow = false
      // this.templateName = '导入LEC'
      // this.uploadFileProps.active = 0
      // this.uploadFileProps.visible = true
    },
    // 下载模板
    async exportTemplate() {
      let err = null
      let res = null
      if (this.templateName === '导入LS') {
        ;[err, res] = await equipmentFacilityRiskThinkTankApi.importFromExcelTemplateFileLS()
      } else {
        ;[err, res] = await equipmentFacilityRiskThinkTankApi.importFromExcelTemplateFileLEC()
      }
      if (!err) {
        this.downLoadExcel(
          this.templateName === '导入LS' ? '设备设施清单LS模板' : '设备设施清单LEC模板',
          res
        )
        this.$message({
          showClose: true,
          message: '模板下载成功',
          type: 'success',
        })
      }
    },
    // 上传文件
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append('input', value)
      })
      const [err, res] = await designVolumeApi.callImport({ file: formData.get('file') })
      if (!err) {
        this.$message.success({
          showClose: true,
          message: '导入成功',
        })
        this.uploadFileProps.active = 2
        this.uploadFileProps.successCount = res.successfullyCount
        this.uploadFileProps.failureCount = res.failureCount
        this.uploadFileProps.buffer = res.steamContent
        this.uploadFileProps.resultFile = 1
        this.getCatalogData()
        this.getDesignList()
      }
      this.uploadFileProps.btnLoading = false
    },
    // 导出？是否没必要
    exportResults() {},
  },
}
</script>
<style scoped lang="scss"></style>
